import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API_BASE,
  withCredentials: true,
});

// Attach token + current production id automatically
api.interceptors.request.use((cfg) => {
  const t = localStorage.getItem("sc_token");
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  const pid = localStorage.getItem("sc_pid");
  if (pid) {
    const url = cfg.url || "";
    // Endpoints that do NOT need production_id
    const skip =
      url.startsWith("/auth") ||
      url.startsWith("/enroll") ||
      url.startsWith("/platform") ||
      url.startsWith("/public") ||
      url.startsWith("/changelog") ||
      url.startsWith("/feedback") ||
      url === "/productions" ||
      url.startsWith("/productions?") ||
      /^\/productions\/[\w-]+(\/|$|\?)/.test(url);
    if (!skip) {
      // don't clobber if caller already set it in params
      if (!cfg.params) cfg.params = {};
      if (cfg.params.production_id == null) cfg.params.production_id = pid;
    }
  }
  return cfg;
});

export function setProductionId(id) {
  if (id) localStorage.setItem("sc_pid", id);
  else localStorage.removeItem("sc_pid");
}
export function getProductionId() {
  return localStorage.getItem("sc_pid") || null;
}

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
